import { render, staticRenderFns } from "./Grants.vue?vue&type=template&id=78e3a21a&"
import script from "./Grants.vue?vue&type=script&lang=js&"
export * from "./Grants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports